import React, { useEffect, useState, Suspense } from "react";
import "./App.css";
import { Canvas } from "@react-three/fiber";
import { EffectComposer, Bloom } from "@react-three/postprocessing";
import { Routes, Route, useLocation } from 'react-router-dom';

import Controls from "./UI/Controls/Controls";
import SceneManager from "./Scene/SceneManager/SceneManager";
import { Leva } from "leva";
import ModalManager from "./UI/Modals/ModalManager";
import { AdaptiveDpr, AdaptiveEvents, Preload } from "@react-three/drei";
import Login from "./UI/Login/Login";
import Admin from "./UI/Admin/Admin";
import Loader from "./Scene/Loader/Loader";
import TutorialModal from "./UI/Modals/TutorialModal/TutorialModal";
import StateIndicator from "./UI/StateIndicator/StateIndicator";
import { initGA, logPageView, logEvent } from "./analytics";
// Composant pour la page principale
function MainPage() {
  const [showTutorial, setShowTutorial] = useState(false);

  const handleCloseTutorial = () => {
    setShowTutorial(false);
  };

  return (
    <>
      <div className="App">
        <Leva collapsed={false} />
        <Suspense fallback={
          <div>
            <h1>Loading...</h1>
          </div>
        }>
          <Canvas >
            <AdaptiveDpr pixelated />
            <AdaptiveEvents />
            <SceneManager></SceneManager>
          </Canvas>
        </Suspense>
      </div>
      <Controls></Controls>
      <ModalManager></ModalManager>
      <StateIndicator />
      <button
        className="help-button"
        onClick={() => {
          setShowTutorial(true);
          logEvent('ui_interaction', 'help_button_click');
        }}
      >
        ?
      </button>
      {showTutorial && <TutorialModal onClose={handleCloseTutorial} />}
      <Login />
    </>
  );
}

// Composant pour suivre les changements de route
function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    logPageView();
  }, [location]);

  return null;
}

function App() {
  useEffect(() => {
    // Initialiser GTM
    initGA();
    // Premier pageview
    logPageView();
  }, []);

  return (
    <>
      {/* <Loader /> */}
      <RouteTracker />
      <Routes>
        <Route path="/update-password" element={<Login />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/" element={<MainPage />} />
      </Routes>
    </>
  );
}

export default App;
